export enum FlowChartNodeType {
  CONTENT = 'content',
  GOTO = 'goto',
  STARTING_STEP = 'startingStep',
  SMART_DELAY = 'smartDelay',
  SPLIT = 'split',
  CONDITION = 'condition',
  ACTION = 'action',
  COMMENT = 'comment',
}
